import React from 'react';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';
import { Currency, formatCurrency } from '@chargify/formatters';
import {
  BodyText,
  Box,
  Column,
  Row,
  SummaryTable,
} from '@chargify/custom-ui-components';
import { Summary as Wrapper } from '../Summary';
import { mapChargeSummaryToTable } from './utils/mapChargeSummaryToTable';
import { TotalCharge } from '../TotalCharge';
import { ChangePlanPreview } from '../../machines/changePlan';

type Props = {
  currency: Currency;
  changePlanPreview: ChangePlanPreview;
};
export const PlanChangeSummaryCharges = ({
  changePlanPreview,
  currency,
}: Props) => {
  const { t } = useTranslation(['subscriptions-manager']);
  return (
    <Wrapper paddingX={5} paddingTop={2} marginBottom={6}>
      <TotalCharge>
        <SummaryTable
          rows={mapChargeSummaryToTable({
            changePlanPreview,
            t,
            language: i18n.language,
            currency,
          })}
          columnSpans={[12, 12]}
        />
      </TotalCharge>
      <Box paddingTop={3} paddingBottom={4}>
        <Row>
          <Column span={12}>
            <BodyText variant="body1" color="success.main" fontWeight={3}>
              {t('plan_change.total_charge')}
            </BodyText>
          </Column>
          <Column span={12}>
            <BodyText
              variant="body1"
              color="success.main"
              textAlign="right"
              fontWeight={3}
            >
              {formatCurrency(
                currency,
                changePlanPreview.totalInCents > 0
                  ? changePlanPreview.totalInCents
                  : 0,
                i18n.language
              )}
            </BodyText>
          </Column>
        </Row>
      </Box>
    </Wrapper>
  );
};
